<section class="vm-card">
  <header class="vm-card__header">
    <img class="vm-card__logo" [src]="logoSrc" alt="Virgin Mobile" />
  </header>
  <div class="vm-card__content">
    <ng-content></ng-content>
  </div>
  @if (footerType == 1) {
    <div class="polygon"></div>
  }
</section>
